import { APIClient } from "api/api_helper";
import { AdverseEvent_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";
import { AdverseEvent } from "modules/Library/AdverseEvent/helper/adverseevent.types";

const api = new APIClient();
export const adverseEventApiService = {

    getSelectAll: (data: AdverseEvent) => {
        return api.create(AdverseEvent_API.AdverseEvent_API + "SelectAll", data);
    },


    getSelectById: (data: AdverseEvent) => {
        return api.create(AdverseEvent_API.AdverseEvent_API + "Select", data);
    },
    
    insertData: (data: Partial<AdverseEvent>) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            ...data,
            createdby: user.userid,
        };
        return api.create(AdverseEvent_API.AdverseEvent_API + "Insert", payload);
    },

    updateData: (data: Partial<AdverseEvent>) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            ...data,
            updatedby: user.userid,
        };
        return api.create(AdverseEvent_API.AdverseEvent_API + "Update", payload);
    },

    deleteData: (data: Partial<AdverseEvent>) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            ...data,
            updatedby: user.userid,
        };
        return api.create(AdverseEvent_API.AdverseEvent_API + "Delete", payload);
    },

    verifyData: (data: any) => {
        return api.create(AdverseEvent_API.AdverseEvent_API + "Verify", data);
    }
};
